import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSidebarLeftHide16Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconSidebarLeftHide16Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6 3h7a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H6zM1 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm10.083 1.989a.5.5 0 1 0-.707-.707l-2.121 2.12-.354.354.354.354 2.12 2.121a.5.5 0 1 0 .708-.707L9.315 7.756z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSidebarLeftHide16Filled);
